import { render, staticRenderFns } from "./WarningIndex.vue?vue&type=template&id=7655b790&scoped=true&"
import script from "./WarningIndex.vue?vue&type=script&lang=ts&"
export * from "./WarningIndex.vue?vue&type=script&lang=ts&"
import style0 from "./WarningIndex.vue?vue&type=style&index=0&id=7655b790&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7655b790",
  null
  
)

export default component.exports